import { Box, InputCheckBox } from "@itandi/itandi-bb-ui";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import type { DealSearchCondition, SearchApplicationType } from "~/models/Deal";

type Props = {
	applicationType: SearchApplicationType;
	dealSearchCondition: DealSearchCondition;
	label: string;
	onCheckedChange?: (checked: boolean) => void;
};

export function ApplicationTypeCheckBox({
	applicationType,
	label,
	dealSearchCondition,
	onCheckedChange
}: Props) {
	const { setValue, getValues } = useFormContext<DealSearchCondition>();
	const { applicationTypes: applicationTypesFromParam } = dealSearchCondition;
	const defaultCheck = (): boolean => {
		if (applicationTypesFromParam) {
			return applicationTypesFromParam.includes(applicationType);
		}
		return false;
	};

	const [checked, setChecked] = useState(defaultCheck);
	const onChangeApplicationType = React.useCallback((): void => {
		const applicationTypes = getValues("applicationTypes") ?? [];
		const nextChecked = !checked;
		if (nextChecked) {
			// 追加
			if (!applicationTypes.includes(applicationType)) {
				applicationTypes.push(applicationType);
			}
		} else {
			// 削除
			applicationTypes.splice(applicationTypes.indexOf(applicationType), 1);
		}
		setValue("applicationTypes", applicationTypes);
		setChecked(nextChecked);
		onCheckedChange?.(nextChecked);
	}, [checked, applicationType, getValues, setValue, onCheckedChange]);
	return (
		<Box margin={4} minWidth={0}>
			<InputCheckBox
				checked={checked}
				label={label}
				onChange={onChangeApplicationType}
			/>
		</Box>
	);
}
